import { ChatPageModule } from './../chat/chat.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


import { IonicModule } from '@ionic/angular';

import { UserPageRoutingModule } from './user-routing.module';

import { UserPage } from './user.page';
// import { SafePipe } from 'src/app/pipes/dom-sanitizer/dom-sanitizer.pipe';
import dayGridPlugin from '@fullcalendar/daygrid';
import { FullCalendarModule } from '@fullcalendar/angular';
import { CustomPipesModule } from 'src/app/pipes/pipes.module';
import { GoogleMapsModule } from '@angular/google-maps';
import { SwiperModule } from 'swiper/angular';
import { SharedModule } from 'src/app/components/shared/shared.module';

FullCalendarModule.registerPlugins([
  dayGridPlugin
]);

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    UserPageRoutingModule,
    FullCalendarModule,
    GoogleMapsModule,
    CustomPipesModule,
    ChatPageModule,
    SwiperModule,
    SharedModule
  ],
  declarations: [UserPage]
})
export class UserPageModule {}
